// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"eX-z","trustedRetailerTooltipWrapper":"fX-z"};